<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-download mr-5"></i>{{'AnalyseCsvGenerator' | translate}}</h3>
      </div>
      <div class="box-body">
        <div class="row alert alert-danger" v-if="alert">
          <div class="col-12 danger">
            <i class="icon fa fa-warning"></i>
            {{this.alertMessage.message | translate}}
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5 col-lg-12 pull-left">
            <h4>{{'create_new_csv_file' | translate}}</h4>
            <div class="row">
              <div class="col-xs-12 col-lg-3">
                <div class="input-group">
                  <div class="input-group-addon">
                    <i class="fa fa-calendar mr-5">&nbsp;{{"FromDate"|translate}}</i>
                  </div>
                  <datepicker input-class="form-control pepe" calendar-class="datepicker"
                              v-model="selectFromDate"></datepicker>
                </div>
              </div>
              <div class="col-xs-12 col-lg-3">
                <div class="input-group">
                  <div class="input-group-addon">
                    <i class="fa fa-calendar mr-5">&nbsp;{{"ToDate"|translate}}</i>
                  </div>
                  <datepicker input-class="form-control pepe" calendar-class="datepicker"
                              v-model="selectToDate"></datepicker>
                </div>
              </div>
              <div class="col-xs-12 col-lg-3">
                <div class="input-group">
                  <div class="input-group-addon">
                    <i class="fa fa-credit-card mr-5">&nbsp;{{"Marketplace"|translate}}</i>
                  </div>
                  <select class="form-control" v-model="selectMarketplace">
                    <option class="normal" value="select">{{'select_one' |
                      translate}}
                    </option>
                    <option class="normal" value="12">{{'mirapodo' |
                      translate}}
                    </option>
                    <option class="normal" value="20">{{'check24' |
                      translate}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12 col-lg-3">
                <button class="btn btn-success pull-right" @click="getAnalyse">
                  <i class="fa fa-cloud-download mr-5"></i>{{'getAnalyse' |
                  translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

  export default {
    data() {
      return {
        selectMarketplace: '',
        selectToDate: '',
        selectFromDate: '',
        alert: false,
        alertMessage: ''
      }
    },
    methods: {
      checkInput() {
        if(this.selectMarketplace!=='' && this.selectToDate!=='' && this.selectFromDate!==''){
          return true
        }
        return false
      },
      getAnalyse() {
        if(!this.checkInput()){

          this.alertMessage={
            dismiss: 4,
            type: 'danger',
            message: "please_enter_all_data",
            icon: 'icon fa fa-check',
            show: true
          }
          this.alert=true;
          return false
        }

        API.get('controlling/analyse/orders/' + moment(this.selectFromDate).format('YYYY-MM-DD') + '/' + moment(this.selectToDate).format('YYYY-MM-DD') + '/' + this.selectMarketplace)
          .then(res => {
            this.alert=false;
            this.alertMessage='';
            let link = document.createElement('a')
            link.setAttribute('href', res.data)
            document.body.appendChild(link)
            link.click()
          }).catch(error => {
          this.alertMessage={
            dismiss: 4,
            type: 'danger',
            message: error.response.data.message,
            icon: 'icon fa fa-check',
            show: true
          }
          this.alert=true;
        })
      }
    }
  }
</script>
<style>
  .datepicker {
    color: white;
    background-color: #212228;
    border: 1px solid rgba(255, 255, 255, .15);
  }

  .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover {
    background-color: #00c396;
  }

  .vdp-datepicker__calendar .cell.selected {
    background-color: #00c396;
  }

  .pepe {
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/SapCollectionInvoiceAnalyses.vue